// extracted by mini-css-extract-plugin
module.exports = {"cfwv08q":"cfwv08q","bz872en":"bz872en","l1yd9k2g":"l1yd9k2g"};